
import { supabase } from "@/integrations/supabase/client";
import { EmailTemplate } from "@/types/emailTemplates";

/**
 * Update an existing email template
 */
export async function updateTemplate(
  id: string,
  template: Partial<EmailTemplate>
): Promise<EmailTemplate | null> {
  try {
    console.log(`Updating template with ID: ${id}`);
    
    // Get the current template to determine if we need a new version
    const { data: currentTemplate, error: fetchError } = await (supabase as any)
      .from('email_templates')
      .select('*')
      .eq('id', id)
      .single();

    if (fetchError) {
      throw new Error(`Error fetching current template: ${fetchError.message}`);
    }

    // If html_content or subject changed, create new version
    const needsNewVersion = 
      template.html_content !== undefined && 
      template.html_content !== currentTemplate.html_content ||
      template.subject !== undefined &&
      template.subject !== currentTemplate.subject;

    const updateData = {
      ...template,
      updated_at: new Date().toISOString(),
      ...(needsNewVersion ? { version: currentTemplate.version + 1 } : {})
    };

    const { data, error } = await (supabase as any)
      .from('email_templates')
      .update(updateData)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      throw new Error(`Error updating template: ${error.message}`);
    }

    return data as EmailTemplate;
  } catch (error: any) {
    console.error("Error in updateTemplate:", error);
    throw new Error(`Failed to update email template: ${error.message}`);
  }
}
